import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import auth from 'reducers/authReducer';
import sessions from 'reducers/sessionsReducer';
import profile from 'reducers/profileReducer';
import deck from 'reducers/deckReducer';
import activeSession from 'reducers/activeSessionReducer';
import paywall from 'reducers/paywallReducer';
import userReferral from 'reducers/userReferralReducer';
import { normalizeRegisterForm } from 'utils/validateNormalize';
import { normalizeClass } from 'views/dashboard/validateClass';
import onboardingVideo from 'reducers/onboardingVideo';
import unsubscribe from 'reducers/unsubscribe';

export default combineReducers({
  form: formReducer.normalize({
    register: normalizeRegisterForm,
    addEditClass: normalizeClass
  }),
  auth,
  sessions,
  profile,
  deck,
  activeSession,
  paywall,
  userReferral,
  onboardingVideo,
  unsubscribe
});



// WEBPACK FOOTER //
// ./src/reducers/index.js